import { gql } from "@apollo/client";

export const GET_CONSUMER_SCHEDULED_REGULAR_SERVICES = gql`
  query ConsumerScheduledRegularServices(
    $businessCustomerId: ID
    $customerId: ID
    $driverId: ID
  ) {
    consumerScheduledRegularServices(
      businessCustomerId: $businessCustomerId
      customerId: $customerId
      driverId: $driverId
    ) {
      services {
        id
        vehicleId
        licencePlate
        referenceNumber
        appointmentDate
        startDate
        serviceCategory
        branchId
      }
    }
  }
`;
